import type { BrandTagListItemVO } from "@/api/system/tags/type";

/** 取品牌名称首字作为色块展示文案 */
export const getBrandAvatarText = (name: string) => name.trim().charAt(0) || "品";

/** 构建选项检索文案：品牌名 + 行业 */
export const buildBrandSearchText = (brand: BrandTagListItemVO) =>
  `${brand.brandName} ${brand.industry ?? ""}`.trim().toLowerCase();
